export const dataNames = {
  'documentType': 'TIPO DE DOCUMENTO',
  'legalRepresentativeType': 'TIPO DE REPRESENTANTE LEGAL',
  'document': 'N° ID',
  'documentFile': '',
  'names': 'NOMBRES',
  'lastNames': 'APELLIDOS / RAZÓN SOCIAL',
  'clientType': 'TIPO DE CLIENTE',
  'dealerReservation': 'DEALER',
  'adviserCode': 'ASESOR',
  'certificate': 'CERTIFICACIÓN DE VERIFICACIÓN DE LA INFORMACIÓN',
  'certificateFile': '',
  'discapacityPerc': 'PORCENTAJE DE DISCAPACIDAD',
  'exonerationPerc': 'PORCENTAJE DE EXONERACIÓN',
  'hasLegalRepresentative': 'REPRESENTANTE LEGAL',
  'legalRepresentativeId': 'N° ID DEL REPRESENTANTE LEGAL',
  'legalRepresentativeName': 'NOMBRE DEL REPRESENTANTE LEGAL',
  'location': 'DIRECCIÓN',
  'city': 'CIUDAD',
  'province': 'PROVINCIA',
  'country': 'PAÍS',
  'phoneNumber': 'TELÉFONO',
  'email': 'EMAIL',
  'line': 'LÍNEA',
  'orderNumber': '',
  'description': '',
  'katashiki': '',
  'sfx': '',
  'externalColor': '',
  'externalColorId': '',
  'internalColor': '',
  'internalColorId': '',
  'chassis': '',
  'motor': '',
  'yearModel': '',
  'fobValue': '',
  'arrivalDate': '',
  'locationText': '',
  'depositDate': 'FECHA DE INGRESO A DEPÓSITO',
  'floatingState': 'ESTADO',
  'reserveAdvance': 'AVANCE DE LA RESERVA',
  'solNacNumber': 'NÚMERO DE SOLICITUD DE NACIONALIZACIÓN',
  'informBillDate': 'FECHA DE FACTURA INFORMATIVA',
  'observations': 'OBSERVACIONES',
  'businessType': 'TIPO DE NEGOCIO',
  'contributorCode': 'CÓDIGO DE CONTRIBUYENTE',
  'estSaleDate': 'FECHA ESTIMADA DE LIQUIDACIÓN',
  'estBillDate': 'FECHA ESTIMADA DE FACTURACIÓN',
  'dealerRuc': 'DEALER',
};
